import { HOME_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import type { TransitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";

/**
 * Redirects away from a restricted SI route; pass the same predicate the state's `isHidden` negates.
 * `redirectToState` must never be gated itself, or the redirect loops.
 */
export const salesRouteGate = (
    canAccess: () => boolean,
    redirectToState: string = HOME_PAGE_ROUTE,
): TransitionHookFn => redirectPipe(() => (canAccess() ? undefined : redirectToState));
